<template>
  <section class="gray py-16">
    <div class="text-center" style="width: 53%;margin: auto;">
      <h1>{{$t('faq')}}</h1>
      <div>
        <v-list color="gray">
          <v-list-group prepend-icon="mdi-quora" append-icon="" v-for="(items,i) in aboutQuestionsLists" :key="i">
            <template v-slot:activator>
              <v-list-item-content>
                <h2 class="font-weight-bold">{{items.question}}</h2>
              </v-list-item-content>
            </template>
            <v-list-item>
              <v-row>
                <v-col class="d-flex align-center justify-center" cols="1">
                  <v-icon size="60" color="black">
                    mdi-format-color-text
                  </v-icon>
                  :
                </v-col>
                <v-col cols="11">
                  {{items.answer}}
                </v-col>
              </v-row>
            </v-list-item>

          </v-list-group>
        </v-list>
      </div>
      <v-btn class="my-4" color="warning" x-large depressed>
        <h5 class="black--text"> see the full FAQ</h5>
      </v-btn>
    </div>


  </section>
</template>
<script>
export default {
  name: 'FAQ',
  props: {
    aboutQuestionsLists: {}
  }
}
</script>
